import { render, staticRenderFns } from "./recommendhead.vue?vue&type=template&id=5c8ad9ce&scoped=true"
import script from "./recommendhead.vue?vue&type=script&lang=js"
export * from "./recommendhead.vue?vue&type=script&lang=js"
import style0 from "./recommendhead.vue?vue&type=style&index=0&id=5c8ad9ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ad9ce",
  null
  
)

export default component.exports